<div class="pt-3 pl-md-4" *ngIf="entryPassNotFound">
  <h2>Pass not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingEntryPass">
  <h2>Loading Pass...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewEntryPass ? 'create' : 'edit' }}
    entry passes.
  </h2>
</div>

<div *ngIf="(serverError === null) && !entryPassNotFound && !loadingExistingEntryPass && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/memberships-and-passes" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('setup');$event.preventDefault();"
           [class.active]="currentSectionId === 'setup'">
          Setup
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('details');$event.preventDefault();"
           [class.active]="currentSectionId === 'details'">
          Details
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('pricing');$event.preventDefault();"
           [class.active]="currentSectionId === 'pricing'">
          Pricing
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('restrictions');$event.preventDefault();"
           [class.active]="currentSectionId === 'restrictions'">
          Restrictions
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('climber-app-text');$event.preventDefault();"
           [class.active]="currentSectionId === 'climber-app-text'">
          Climber App Text
        </a>
      </li>
      <li class="nav-item"
          *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
        <a class="nav-link" href="#"
           (click)="scrollToElement('mailchimp');$event.preventDefault();"
           [class.active]="currentSectionId === 'mailchimp'">
          Mailchimp
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="onSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content" appScrollDetect>

    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5 mb-6">
      <h2>
        {{ isNewEntryPass ? 'New Pass' : 'Edit Pass' }}
      </h2>

      <form (submit)="onSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8"
               appScrollSpy [spiedTags]="['H3']" (sectionChange)="onSectionChange($event)">

            <h3 class="mt-2" id="setup">Setup</h3>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="nameInput">Pass Name *</label>
                <input id="nameInput" type="text" name="name"
                       class="form-control"
                       [(ngModel)]="entryPass.name"
                       (ngModelChange)="unsavedChanges = true">
                <div class="form-text text-danger">{{ errors.name }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="statusSelect">Status *</label>
                <select id="statusSelect" name="status"
                        class="custom-select"
                        [(ngModel)]="entryPass.status"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let status of getAvailableStatuses()"
                          [ngValue]="status">
                    {{ getEntryPassStatusDisplay(status) }}
                  </option>
                </select>
                <small class="form-text text-muted">
                  Once a pass is set to Active (or Retired), it may not be reverted to Draft.
                </small>
                <div class="form-text text-danger">{{ errors.status }}</div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isStaffOnlySelect">Visibility</label>
                  <select id="isStaffOnlySelect" name="visibility"
                          class="custom-select"
                          [(ngModel)]="entryPass.visibility"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="EntryPassVisibility.public">Public</option>
                    <option [ngValue]="EntryPassVisibility.unlisted">Unlisted</option>
                    <option [ngValue]="EntryPassVisibility.staffOnly">Staff Only</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Unlisted entry pass will not be listed as a purchase option on the "Memberships, Passes, and Voucher Packs" Climber App page, but may still be purchased by anyone with the link. Staff Only entry passes may only be purchased by staff members.
              </small>
              <div class="form-text text-danger">{{ errors.visibility }}</div>
            </div>

            <div class="form-group">
              <label for="order_number">Order Number</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <input id="order_number"
                         name="order_number"
                         class="form-control"
                         type="number"
                         step="1"
                         [(ngModel)]="entryPass.order_number"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This determines the order that entry passes are displayed in the Climber App. Lower numbers are displayed first. If two entry passes have the same order number, they will be displayed in the order that they were created.
              </small>
              <div class="form-text text-danger">{{ errors.order_number }}</div>
            </div>

            <h3 class="mt-2" id="details">Pass Details</h3>

            <div class="form-group">
              <label for="numPassesInput">Number of Entries *</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="numPassesInput" type="number" name="num_passes"
                         min="0" max="100000" step="1"
                         class="form-control"
                         [(ngModel)]="entryPass.num_passes"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.num_passes }}</div>
            </div>

            <div class="form-group">
              <label for="expirationMonthsInput">Months Until Expiration</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="expirationMonthsInput" type="number" name="expiration_months"
                         min="1" max="120" step="1"
                         class="form-control"
                         [(ngModel)]="entryPass.expiration_months"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                The number of months that the pass lasts before expiring. If this and "Days Until Expiration" are left blank, the pass will not expire.
              </small>
              <div class="form-text text-danger">{{ errors.expiration_months }}</div>
            </div>

            <div class="form-group">
              <label for="expirationDaysInput">Days Until Expiration</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="expirationDaysInput" type="number" name="expiration_days"
                         min="0" max="120" step="1"
                         class="form-control"
                         [(ngModel)]="entryPass.expiration_days"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                The number of days that the pass lasts before expiring. If this and "Months Until Expiration" are left blank, the pass will not expire.
                <br>
                If both this and "Months Until Expiration" are provided, the time until expiration will be the sum of the two.
                <br>
                If this is set to zero (and "Months Until Expiration" is left blank), the entry pass will expire at the end of the day that it is purchased.
              </small>
              <div class="form-text text-danger">{{ errors.expiration_days }}</div>
            </div>

            <h3 class="mt-2" id="pricing">Pass Pricing</h3>

            <div class="form-group">
              <label for="priceInput">Pass Price *</label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4 col-sm-5">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                  </div>
                  <input id="priceInput" type="number" name="price"
                         placeholder="XXX.XX" min="0" step="0.01"
                         class="form-control"
                         [(ngModel)]="entryPass.price"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.price }}</div>
            </div>

            <div class="form-group"  *ngIf="getLocations() && (getLocations().length > 1)">
              <label>Location-Specific Prices</label>

              <table class="table table-bordered table-sm mb-1 border-0">
                <thead>
                <tr>
                  <th>Locations</th>
                  <th>Price</th>
                  <th class="border-0 edit-and-remove-cell"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let pricingMatrix of entryPass.location_specific_pricing_matrices; let matIdx = index;">
                  <td>
                    <span class="d-block" *ngFor="let locId of pricingMatrix.location_ids">
                      {{ getLocNameById(locId) }}
                    </span>
                  </td>
                  <td>
                    <b>{{ orgConfig.formatCurrency(pricingMatrix.price)}}</b>
                  </td>
                  <td class="border-0 edit-and-remove-cell">
                    <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                            (click)="editPricingMatrix(matIdx)">
                      Edit
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                            (click)="removePricingMatrix(matIdx)">
                      Remove
                    </button>
                  </td>
                </tr>
                <tr *ngIf="entryPass.location_specific_pricing_matrices.length === 0">
                  <td colspan="2" class="text-muted">No Per-Location Prices Configured</td>
                </tr>
                </tbody>
              </table>

              <button type="button" class="btn btn-sm btn-outline-primary"
                      (click)="addPricingMatrix()">
                Add Location-Specific Price
              </button>

              <div class="form-text text-danger">
                {{ errors.location_specific_pricing_matrices }}
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-6 col-md-8">
                <label for="taxRateSelect">Tax Rate *</label>
                <div class="float-right">
                  <a href="#"
                     (click)="$event.preventDefault();loadTaxRates();">
                    Refresh Tax Rates
                  </a>
                  |
                  <a routerLink="/tax-rates-config" target="_blank">
                    Configure Tax Rates
                  </a>
                </div>
                <select id="taxRateSelectLoading" class="custom-select" name="tax_rate"
                        *ngIf="loadingTaxRates" disabled>
                  <option>Loading...</option>
                </select>
                <select id="taxRateSelect" class="custom-select" name="tax_rate"
                        *ngIf="!loadingTaxRates"
                        [(ngModel)]="entryPass.tax_rate_id"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngIf="taxRateRemoved(entryPass.tax_rate_id)"
                          [ngValue]="entryPass.tax_rate_id">
                    {{ entryPass.tax_rate_name }} (Removed)
                  </option>
                  <option *ngFor="let taxRate of taxRateList"
                          [ngValue]="taxRate.id">
                    {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                  </option>
                </select>
                <div class="form-text text-danger">{{ errors.tax_rate_id }}</div>
              </div>
            </div>

            <div class="row" *ngIf="getLocations() && (getLocations().length > 1)">
              <div class="form-group col-lg-8 col-md-10">
                <div class="indented-subsection">
                  <div class="form-check mb-2">
                    <input type="checkbox"
                           id="hasPerLocationTaxRates"
                           name="hasPerLocationTaxRates"
                           class="form-check-input"
                           [(ngModel)]="hasPerLocationTaxRates"
                           (ngModelChange)="unsavedChanges = true">
                    <label class="form-check-label" for="hasPerLocationTaxRates">
                      Configure tax rate by location
                    </label>
                  </div>

                  <ng-container *ngIf="hasPerLocationTaxRates">
                    <p class="text-muted mb-2" *ngIf="Object.keys(entryPass.tax_rate_per_location).length === 0">
                      No locations selected
                    </p>

                    <div class="mb-2" *ngFor="let locId of Object.keys(entryPass.tax_rate_per_location)">
                      <div class="row">
                        <div class="col-5 pr-0">
                          <input type="text"
                                 class="form-control form-control-sm disabled"
                                 disabled
                                 value="{{ getLocNameById(locId) }}">
                        </div>
                        <div class="col-5 pr-0">
                          <select class="custom-select custom-select-sm"
                                  *ngIf="loadingTaxRates" disabled>
                            <option>Loading...</option>
                          </select>
                          <select class="custom-select custom-select-sm"
                                  name="tax_rate{{ locId }}"
                                  *ngIf="!loadingTaxRates"
                                  [(ngModel)]="entryPass.tax_rate_per_location[locId]"
                                  (ngModelChange)="unsavedChanges = true">
                            <option *ngIf="taxRateRemoved(entryPass.tax_rate_per_location[locId])"
                                    [ngValue]="entryPass.tax_rate_per_location[locId]">
                              (Removed Tax Rate)
                            </option>
                            <option *ngFor="let taxRate of taxRateList"
                                    [ngValue]="taxRate.id">
                              {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                            </option>
                          </select>
                        </div>
                        <div class="col-2">
                          <button class="btn btn-sm btn-danger"
                                  (click)="unsavedChanges = true; deleteProp(entryPass.tax_rate_per_location, locId);">
                            X
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn btn-sm btn-outline-primary d-block"
                            type="button"
                            [disabled]="loadingTaxRates || (taxRateList.length === 0)"
                            [class.disabled]="loadingTaxRates || (taxRateList.length === 0)"
                            (click)="addTaxRateLocation()">
                      Add Location
                    </button>

                    <div class="form-text text-danger">{{ errors.tax_rate_per_location }}</div>
                    <small class="form-text text-muted">
                      A per-location tax rate will replace the default tax rate configured above.
                    </small>
                  </ng-container>
                </div>
              </div>
            </div>

            <h3 class="mt-2" id="restrictions">Pass Restrictions</h3>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowUnlinkedPurchaseSelect">Allow Purchase for Unlinked Customers</label>
                  <select id="allowUnlinkedPurchaseSelect" name="allow_purchasing_for_unlinked_customers"
                          class="custom-select"
                          [(ngModel)]="entryPass.allow_purchasing_for_unlinked_customers"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then customers may manually enter the passholder's name and birthday when purchasing an entry pass, in addition to the options of purchasing the pass for themselves or a linked customer. If the manually-entered details cannot be matched to an existing customer, a new customer account will be created.
              </small>
              <div class="form-text text-danger">{{ errors.allow_purchasing_for_unlinked_customers }}</div>
            </div>

            <div class="form-group" *ngIf="entryPass.allow_purchasing_for_unlinked_customers">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowPurchaseWithoutLoginSelect">Allow Purchase when Not Logged Into Climber App</label>
                  <select id="allowPurchaseWithoutLoginSelect" name="allow_purchase_without_login"
                          class="custom-select"
                          [(ngModel)]="entryPass.allow_purchase_without_login"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then customers may purchase this entry pass without being logged in to the Climber App. They will be asked to enter their name, birthday, and email address instead.
              </small>
              <div class="form-text text-danger">{{ errors.allow_purchase_without_login }}</div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="hasLimitedEntrySelect">
                  Is this entry pass limited to entry at certain days/times?
                </label>
                <select id="hasLimitedEntrySelect" name="has_limited_entry"
                        class="custom-select"
                        [(ngModel)]="entryPass.has_limited_entry"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
                <div class="form-text text-danger">{{ errors.has_limited_entry }}</div>
              </div>
            </div>

            <div class="form-group indented-subsection" *ngIf="entryPass.has_limited_entry">
              <p><b>Times when this entry pass may be used for entry:</b></p>

              <ng-container *ngFor="let timeSlot of entryTimeSlots">
                <div class="form-group">
                  <div class="row">
                    <div class="col-4">
                      <label>Start Time *</label>
                      <input type="time" step="60"
                             class="form-control"
                             [name]="'startTime' + timeSlot.id.toString()"
                             [(ngModel)]="timeSlot.start_time"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="form-text text-danger"
                           *ngIf="entryTimeSlotErrors[timeSlot.id]">
                        {{ entryTimeSlotErrors[timeSlot.id].start_time }}
                      </div>
                    </div>
                    <div class="col-4">
                      <label>End Time *</label>
                      <input type="time" step="60"
                             class="form-control"
                             [name]="'endTime' + timeSlot.id.toString()"
                             [(ngModel)]="timeSlot.end_time"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="form-text text-danger"
                           *ngIf="entryTimeSlotErrors[timeSlot.id]">
                        {{ entryTimeSlotErrors[timeSlot.id].end_time }}
                      </div>
                    </div>
                    <div class="col-4">
                      <button class="btn btn-danger btn-sm float-right"
                              (click)="removeEntryTimeSlot(timeSlot); unsavedChanges = true;">
                        Remove Time Slot
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Days Available *</label>
                  <br>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_sunday"
                          [class.btn-primary]="timeSlot.is_available_sunday"
                          (click)="timeSlot.is_available_sunday = !timeSlot.is_available_sunday; unsavedChanges = true;">
                    S
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_monday"
                          [class.btn-primary]="timeSlot.is_available_monday"
                          (click)="timeSlot.is_available_monday = !timeSlot.is_available_monday; unsavedChanges = true;">
                    M
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_tuesday"
                          [class.btn-primary]="timeSlot.is_available_tuesday"
                          (click)="timeSlot.is_available_tuesday = !timeSlot.is_available_tuesday; unsavedChanges = true;">
                    T
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_wednesday"
                          [class.btn-primary]="timeSlot.is_available_wednesday"
                          (click)="timeSlot.is_available_wednesday = !timeSlot.is_available_wednesday; unsavedChanges = true;">
                    W
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_thursday"
                          [class.btn-primary]="timeSlot.is_available_thursday"
                          (click)="timeSlot.is_available_thursday = !timeSlot.is_available_thursday; unsavedChanges = true;">
                    T
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_friday"
                          [class.btn-primary]="timeSlot.is_available_friday"
                          (click)="timeSlot.is_available_friday = !timeSlot.is_available_friday; unsavedChanges = true;">
                    F
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_saturday"
                          [class.btn-primary]="timeSlot.is_available_saturday"
                          (click)="timeSlot.is_available_saturday = !timeSlot.is_available_saturday; unsavedChanges = true;">
                    S
                  </button>
                  <br>
                  <button class="btn btn-link btn-sm pl-0" type="button"
                          *ngIf="!allDaysAreAvailable(timeSlot)"
                          (click)="setAllDaysAvailability(timeSlot, true); unsavedChanges = true;">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm pl-0" type="button"
                          *ngIf="allDaysAreAvailable(timeSlot)"
                          (click)="setAllDaysAvailability(timeSlot, false); unsavedChanges = true;">
                    Deselect All
                  </button>
                </div>

                <div class="alert alert-danger" role="alert"
                     *ngIf="entryTimeSlotErrors[timeSlot.id] && entryTimeSlotErrors[timeSlot.id].non_field_errors">
                  {{ entryTimeSlotErrors[timeSlot.id].non_field_errors }}
                </div>

                <hr>
              </ng-container>

              <button class="btn btn-sm btn-link pl-0 mb-3" type="button"
                      (click)="addNewEntryTimeSlot(); unsavedChanges = true;">
                + Add New Time Period
              </button>
            </div>

            <h3 class="mt-2" id="climber-app-text">Climber App Text</h3>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Pass Description</label>
                <app-markdown-editor [id]="'descriptionTextarea'"
                                     [(content)]="entryPass.description"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be viewable by customers if they can purchase this pass online.
                </small>
                <div class="form-text text-danger">{{ errors.description }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Terms and Conditions Checkbox Text</label>
                <app-markdown-editor [id]="'tsAndCsCheckboxText'"
                                     [(content)]="entryPass.terms_and_conditions_checkbox_text"
                                     (contentChange)="unsavedChanges = true">
                </app-markdown-editor>
                <small class="form-text text-muted">
                  This text will be shown alongside a checkbox which must be checked by the customer before purchasing this pass. If this is left blank, no checkbox will be shown and it will not be required.
                </small>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Pass Confirmation Text</label>
                <app-markdown-editor [id]="'confirmationTextArea'"
                                     [(content)]="entryPass.confirmation_text"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be shown to customers on the confirmation screen after they purchase this pass online.
                </small>
                <div class="form-text text-danger">{{ errors.confirmation_text }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Payment Information Text</label>
                <app-markdown-editor [id]="'paymentInfoTextArea'"
                                     [(content)]="entryPass.payment_information_text"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be shown to customers on their receipt after they purchase this pass online.
                </small>
                <div class="form-text text-danger">{{ errors.payment_information_text }}</div>
              </div>
            </div>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
              <h3 class="mt-2" id="mailchimp">Mailchimp Tags and Events</h3>

              <p class="text-muted">
                To learn more, see our
                <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
                   target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
              </p>

              <p class="mb-1">
                The following tags and events are synced to Mailchimp automatically for all entry passes:
              </p>
              <div class="rounded-table-wrapper rounded-table-tight mb-3 mailchimp-auto-events-table">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Synced To</th>
                      <th>When</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Has Unused Entry Passes</td>
                      <td>Tag</td>
                      <td>Customer</td>
                      <td>While the customer has at least one unused entry pass</td>
                    </tr>
                    <tr>
                      <td><code>used_last_entry_pass</code></td>
                      <td>Event</td>
                      <td>Customer</td>
                      <td>When the customer uses the last entry in a multiple-entry pass</td>
                    </tr>
                    <tr>
                      <td><code>used_single_entry_pass</code></td>
                      <td>Event</td>
                      <td>Customer</td>
                      <td>When the customer uses a single-entry pass</td>
                    </tr>
                    <tr>
                      <td><code>entry_pass_purchased_by_cust</code></td>
                      <td>Event</td>
                      <td>Owner</td>
                      <td>When an entry pass of this type is purchased</td>
                    </tr>
                    <tr>
                      <td><code>entry_pass_purchased_for_cust</code></td>
                      <td>Event</td>
                      <td>Linked Customer</td>
                      <td>When an entry pass of this type is purchased</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form-group">
                <label for="mailchimpUnusedPassesTagNameInput">
                  "Unused Passes" Tag Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpUnusedPassesTagNameInput"
                           type="text" name="mailchimp_unused_passes_tag_name"
                           maxlength="64"
                           class="form-control"
                           [(ngModel)]="entryPass.mailchimp_unused_passes_tag_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this tag will be assigned in Mailchimp to all customers with unused entry passes (passes with at least one use remaining) of this type.
                  <br>
                  It may take up to 15 minutes to update all existing customers when this field is changed.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_unused_passes_tag_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpLastEntryUsedEventNameInput">"Last Entry Used" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpLastEntryUsedEventNameInput"
                           type="text" name="mailchimp_last_entry_used_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="entryPass.mailchimp_last_entry_used_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp whenever a customer uses their last entry of a pass of this type. This is in addition to the generic "{{ entryPass.num_passes === 1 ? 'used_single_entry_pass' : 'used_last_entry_pass' }}" event, which is created for all {{ entryPass.num_passes === 1 ? 'single-use' : 'multiple-use' }} entry pass types.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_last_entry_used_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedByCustomerEventNameInput">
                  "Entry Pass Purchased By Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedByCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_by_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="entryPass.mailchimp_purchased_by_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the entry pass owner whenever an entry pass of this type is purchased. This is in addition to the generic "entry_pass_purchased_by_cust" event, which is created for the owner on all entry pass purchases.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_purchased_by_customer_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedForCustomerEventNameInput">
                  "Entry Pass Purchased For Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedForCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_for_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="entryPass.mailchimp_purchased_for_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for each linked customer whenever an entry pass of this type is purchased. This is in addition to the generic "entry_pass_purchased_for_cust" event, which is created for each linked customer on all entry pass purchases.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_purchased_for_customer_event_name }}</div>
              </div>
            </ng-container>

            <app-last-updated-by-footer
              [updatedAt]="entryPass.updated_at"
              [firstName]="entryPass.last_updated_by_first_name"
              [lastName]="entryPass.last_updated_by_last_name"
              [email]="entryPass.last_updated_by_email"
            ></app-last-updated-by-footer>

          </div>
        </div>
      </form>
    </div>

  </div>
</div>
